import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_MONEDAS = 'ALL_MONEDAS';
export const LOADING_ALL_MONEDAS = 'LOADING_ALL_MONEDAS';
export const ACTIVO_MONEDAS = 'ACTIVO_MONEDAS';
export const PARAMS_MONEDAS = 'PARAMS_MONEDAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const monedasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_MONEDAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_MONEDAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_MONEDAS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_MONEDAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
